import i18n from "@/locales";

export default [
    {
        path: "/app-pages/bankTransfer",
        name: "bankTransfer",
        component: () => import("@/views/app-pages/bankTransfer/bankTransfer.vue"),
        meta: {
            showHeader: false,
            title: i18n.t("bankTransfer.b000020")
        }
    },
    {
        path: "/app-pages/fundsTransfer",
        name: "fundsTransfer",
        component: () => import("@/views/app-pages/fundsTransfer/fundsTransfer.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("fundsTransfer.f000006")
        }
    },
    {
        path: "/app-pages/transferRecords",
        name: "transferRecords",
        component: () => import("@/views/app-pages/records/transferRecords.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("fundsTransfer.f000012")
        }
    },
    {
        path: "/app-pages/exchange",
        name: "exchange",
        component: () => import("@/views/app-pages/records/exchange.vue"),
        meta: {
            showHeader: true,
            title:  i18n.t("moneyExchange.m000011")
        }
    },
    {
        path: "/app-pages/moneyExchange",
        name: "moneyExchange",
        component: () => import("@/views/app-pages/moneyExchange/moneyExchange.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("moneyExchange.m000018")
        }
    },
    {
        path: "/app-pages/into-bank-card-list",
        name: "into-bank-card-list",
        component: () => import("@/views/app-pages/transferInto/intoBankCardList.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("funds.pageTitle[2]")
        }
    },
    {
        path: "/app-pages/transfer-into-abroad",
        name: "transfer-into-abroad",
        component: () => import("@/views/app-pages/transferInto/transferIntoAbroad.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("funds.pageTitle[3]")
        }
    },
    {
        path: "/app-pages/credentials-upload",
        name: "credentials-upload",
        component: () => import("@/views/app-pages/transferInto/credentialsUpload.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("funds.pageTitle[4]")
        }
    },
    {
        path: "/app-pages/withdraw",
        name: "Withdraw",
        component: () => import("@/views/app-pages/withdraw/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("withdraw.nav_title")
        }
    },
    {
        path: "/app-pages/notice",
        name: "Notice",
        component: () => import("@/views/app-pages/agencyList/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("agencyList.lang")
        }
    },
    {
        path: "/app-pages/message",
        name: "message",
        component: () => import("@/views/app-pages/message/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("agencyList.lang")
        }
    },
    {
        path: "/app-pages/resetTradePwd",
        name: "resetTradePwd",
        component: () => import("@/views/app-pages/resetTradePwd/resetTradePwd.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("m000034")
        }
    },
    {
        path: "/app-pages/modTradePwd",
        name: "modTradePwd",
        component: () => import("@/views/app-pages/modTradePwd/modTradePwd.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("m000033")
        }
    },
    {
        path: "/app-pages/accountAnalysis",
        name: "accountAnalysis",
        component: () => import("@/views/app-pages/accountAnalysis/index.vue"),
        meta: {
            showHeader: true,
            title: i18n.t("accountAnalysis.a00001")
        }
    },
]
